import { useCallback } from 'react';
import { Box } from '@chakra-ui/react';
import { Text, Colors } from '@mercator-gcp/grout';
import { capitalize } from 'lodash';
import Tooltip from 'components/elements/Tooltip';
import { FlexRow } from 'components/layout/FlexRow';
import { useZones } from 'state/projectTypes';
import { Project } from 'types';

type Props = {
  lud: Project['land_use_redesignation'];
  cityId: string;
};

export const Lurd = ({ lud, cityId }: Props) => {
  const proposedLudEntries = Array.from(new Set(lud?.proposedlud?.split(';') || []));
  const { getAllCityLuds } = useZones(cityId);

  const getZoneDescriptionWithCode = useCallback(
    (zoneCode: string) => {
      const zoneDescription = getAllCityLuds()
        .filter((ludObj) => ludObj.code === zoneCode)
        .map((ludObj) => ludObj.description);

      return zoneDescription.length > 0 ? zoneDescription[0] : zoneCode;
    },
    [getAllCityLuds],
  );

  const getParentZoneWithCode = useCallback(
    (zoneCode: string) => {
      const parentZone = getAllCityLuds()
        .filter((ludObj) => ludObj.code.toLowerCase() === zoneCode.toLowerCase())
        .map((ludObj) => ludObj.district);

      return parentZone ? parentZone[0] : zoneCode;
    },
    [getAllCityLuds],
  );

  const ludContainer = {
    maxWidth: '500px',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'left',
  };

  const toLudText = {
    color: Colors.Tangerine700,
    mr: 'padding_8',
  };

  return (
    <FlexRow sx={ludContainer}>
      {proposedLudEntries?.map((entry, index) => {
        const zoneDescription = getZoneDescriptionWithCode(String(entry));
        const parentZoneDescription = getParentZoneWithCode(entry);

        return (
          <Tooltip
            key={entry}
            tooltipText={zoneDescription}
            placement="bottom"
            isDisabled={zoneDescription.length <= 0}
          >
            <Box sx={toLudText}>
              <Text>
                {parentZoneDescription
                  ? `${capitalize(parentZoneDescription)} (${entry}) `
                  : `${entry} `}
                {proposedLudEntries.length > 1 &&
                  index !== proposedLudEntries.length - 1 &&
                  ', '}
              </Text>
            </Box>
          </Tooltip>
        );
      })}
    </FlexRow>
  );
};
